import { Controller } from 'react-hook-form';
import React from 'react';
import {
  Box, Grid, styled, TextField, Typography,
} from '@mui/material';
import { NumberFormatCustom } from './format/number-format-custom';

function CurrencyTextFieldCustom({
  control, name, label, rules = null, size = 'medium', variant = 'standard',
}: any) {
  return (
    <Grid item height={80}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field, fieldState,
        }) => {
          return (
            <Box>
              <CssTextField
                label={label}
                value={field?.value || ''}
                variant={variant}
                placeholder="0,00 €"
                size={size}
                color="secondary"
                onChange={(e) => field.onChange(e.target.value)}
                InputProps={{
                  inputComponent: NumberFormatCustom as any,
                }}
                fullWidth
              />
              {fieldState?.error?.message
                && <Typography variant="caption" fontWeight="bold" color="error">{fieldState.error.message}</Typography>}
            </Box>
          );
        }}
      />
    </Grid>
  );
}

const CssTextField = styled(TextField)(({ theme }) => ({
  label: {
    fontWeight: '400',
    color: theme.palette.text.primary,
  },
}));

export {
  CurrencyTextFieldCustom,
};
